import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'ui/ReactTable';
import { Button } from '@material-ui/core';
import { RedButton } from './Grid.styles';


const Grid = ({ data, onEdit, removeItem }) => (
  <div>
    <ReactTable
      data={data}
      columns={[
        {
          Header: 'ID',
          accessor: 'idStaff',
          maxWidth: 30,
        },
        {
          Header: 'Usuario',
          accessor: 'name',
          maxWidth: 200,
        },
        {
          Header: 'Email',
          accessor: 'email',
        },
        {
          Header: () => <div style={{ textAlign: 'center' }}>Rol</div>,
          accessor: 'roleName',
          maxWidth: 100,
          style: { textAlign: 'center' },
        },
        {
          Header: () => <div style={{ textAlign: 'center' }}>Academia</div>,
          accessor: 'academyName',
          style: { textAlign: 'center' },
        },
        {
          Header: 'Acciones',
          fixed: 'right',
          columns: [
            {
              Cell: row => (
                <Button onClick={() => onEdit(row.original.idStaff)}>Editar</Button>
              ),
              resizable: false,
              sortable: false,
              maxWidth: 70,
            },
            {
              Cell: row => (
                <RedButton onClick={() => removeItem(row.original.idStaff)}>
                    Borrar
                </RedButton>
              ),
              resizable: false,
              sortable: false,
              maxWidth: 100,
            },
          ],
        },
      ]}
    />
  </div>
);

Grid.propTypes = {
  data: PropTypes.array.isRequired,
  onEdit: PropTypes.func.isRequired,
  removeItem: PropTypes.func.isRequired,
};

export default Grid;
